import Colors from 'constants/Colors';

export default {
  container: {
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  hotelSelectorContainer: {
    width: '100%',
    maxWidth: 400,
    minWidth: 220,
    marginTop: 12,
    marginBottom: 12,
  },
  buttonStyle: {
    minWidth: 220,
    maxWidth: 320,
    fontSize: 13,
  },
  title: {
    fontSize: 16,
    color: Colors.darkText,
  },
};
